import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import MyPage from './pages/MyPage';
import Pricing from './pages/Pricing';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutFail from './pages/CheckoutFail';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Guide from './pages/Guide';
import Terms from './pages/Terms';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Shopping from './pages/Shopping';
import Tracking from './pages/Tracking';
import KeywordMulti from './pages/KeywordMulti';
import KeywordRelated from './pages/KeywordRelated';
import SearchMulti from './pages/SearchMulti';
import SearchIntegrated from './pages/SearchIntegrated';
import Involvement from './pages/Involvement';
import Marketing from './pages/Marketing';
import KeywordStrategy from './pages/KeywordStrategy';
import Report from './pages/Report';
import Admin from './pages/Admin';
import PlaceRanking from './pages/PlaceRanking';
import PlaceRankCompare from './pages/PlaceRankCompare';
import ShoppingCompare from './pages/ShoppingCompare';
import CatalogTracker from './pages/CatalogTracker';
import CoupangTracker from './pages/CoupangTracker';
import CoupangRank from './pages/CoupangRank';
import Kin from './pages/Kin';
import PlaceCompetitor from './pages/PlaceCompetitor';
import PlaceRank from './pages/PlaceRank';
import PlaceTracking from './pages/PlaceTracking';
import PlaceCompare from './pages/PlaceCompare';
import Morpheme from './pages/Morpheme';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/mypage" element={<PrivateRoute><MyPage /></PrivateRoute>} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/fail" element={<CheckoutFail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/shopping" element={<PrivateRoute><Shopping /></PrivateRoute>} />
        <Route path="/tracking" element={<PrivateRoute><Tracking /></PrivateRoute>} />
        <Route path="/keyword/multi" element={<PrivateRoute><KeywordMulti /></PrivateRoute>} />
        <Route path="/keyword/related" element={<PrivateRoute><KeywordRelated /></PrivateRoute>} />
        <Route path="/search" element={<PrivateRoute><SearchMulti /></PrivateRoute>} />
        <Route path="/search/integrated" element={<PrivateRoute><SearchIntegrated /></PrivateRoute>} />
        <Route path="/involvement" element={<PrivateRoute><Involvement /></PrivateRoute>} />
        <Route path="/marketing" element={<PrivateRoute><Marketing /></PrivateRoute>} />
        <Route path="/keyword-strategy" element={<PrivateRoute><KeywordStrategy /></PrivateRoute>} />
        <Route path="/report" element={<PrivateRoute><Report /></PrivateRoute>} />
        <Route path="/52-2" element={<Admin />} />
        <Route path="/place/ranking" element={<PlaceRanking />} />
          <Route path="/place/rank-compare" element={<PlaceRankCompare />} />
          <Route path="/shopping/compare" element={<ShoppingCompare />} />
          <Route path="/competitor" element={<ShoppingCompare />} />
          <Route path="/catalog" element={<CatalogTracker />} />
          <Route path="/coupang" element={<CoupangTracker />} />
          <Route path="/coupang-rank" element={<CoupangRank />} />
          <Route path="/55-5" element={<Kin />} />
          <Route path="/place/rank" element={<PrivateRoute><PlaceRank /></PrivateRoute>} />
<Route path="/place/tracking" element={<PrivateRoute><PlaceTracking /></PrivateRoute>} />
        <Route path="/place/competitor" element={<PrivateRoute><PlaceCompetitor /></PrivateRoute>} />
        <Route path="/place/compare" element={<PrivateRoute><PlaceCompare /></PrivateRoute>} />
        <Route path="/morpheme" element={<PrivateRoute><Morpheme /></PrivateRoute>} />
        <Route path="/strategy" element={<PrivateRoute><KeywordStrategy /></PrivateRoute>} />
        <Route path="/" element={<Landing />} />
              <Route path="/privacy" element={<Privacy />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
